import styled, { css } from 'styled-components/macro';

import { themeGet } from '@styled-system/theme-get';

import { themeGetAsRem, themeGetResponsive, rem } from '@blueprint/ui';

import Box from '../Box';

const Pill = styled(Box)`
  ${themeGetAsRem(`pills.base`)};

  ${({ mode }) => themeGet(`pills.variantMapping.${mode}.unselected`)};
  svg {
    fill: ${({ mode }) => (mode === 'light' ? '#333333' : '#ffffff')};
  }

  width: ${({ width }) => width || 'auto'};

  ${({ pillSize, pillIcon }) => css`
    ${themeGetAsRem(`pills.compact.fontSizeMapping.${pillSize}`)};
    ${themeGetAsRem(`pills.compact.sizeMapping.${pillSize}`)};
    ${pillIcon &&
    css`
      padding-left: ${pillSize === 'large' ? rem(7) : rem(4)};
    `};
  `};
  ${({ hMedia }) => css`
    ${themeGetResponsive({
      hMedia,
      hBreakpoints: 'extraLarge',
      hMediaStyles: css`
        ${themeGetAsRem('pills.hBreakpoints.extraLarge.fontSize')};
        ${themeGetAsRem('pills.hBreakpoints.extraLarge.base')};
        ${({ pillIcon }) =>
          pillIcon &&
          css`
            padding-left: ${rem(8)};
          `};
      `,
    })}
    ${themeGetResponsive({
      hMedia,
      mobileFirst: true,
      hBreakpoints: 'extraLarge',
      hMediaStyles: css`
        ${themeGetAsRem('pills.hBreakpoints.extraLarge.fontSize')};
        ${themeGetAsRem('pills.hBreakpoints.extraLarge.base')};
        ${({ pillIcon }) =>
          pillIcon &&
          css`
            padding-left: ${rem(8)};
          `};
      `,
    })}
    ${themeGetResponsive({
      hMedia,
      hMediaStyles: css`
        ${themeGetAsRem('pills.hBreakpoints.medium.fontSize')};
        ${themeGetAsRem('pills.hBreakpoints.medium.base')};
        ${({ pillIcon }) =>
          pillIcon &&
          css`
            padding-left: ${rem(8)};
          `};
      `,
    })}
  `};
`;

export const PillLabel = styled(Pill)`
  ${({ pillSize }) => css`
    padding-bottom: ${pillSize === 'large' && rem(5)};
  `};
  ${({ hMedia }) =>
    themeGetResponsive({
      hMedia,
      hMediaStyles: css`
        padding-bottom: ${rem(7)};
      `,
    })};
`;

export default Pill;
